export const book = {
  title: 'Idea → App Store',
  subtitle: 'How to Build and Ship Your First App With AI',
  description: 'A practical guide to choosing a useful MVP, building with AI, and navigating App Store launch—from an indie developer who has been through the process.',
  articlePath: '/blog/idea-to-app-store',
  cover: `${process.env.PUBLIC_URL}/images/book/idea-to-app-store.jpg`,
  payhipUrl: 'https://payhip.com/b/6gKJm',
  amazonUrl: "https://www.amazon.com/dp/B0HJYNYSPY",
}
